import React, { useEffect, useState } from "react";
import {
  TQuestion,
  TQuiz,
  TQuizAttempt,
} from "../../../../entities/Moodle/model/MoodleTypes";
import { moodleApi, moodleModel } from "../../../../entities/Moodle";
import { Button, Spin } from "antd";
import moment from "moment";
import "./Attempt.scss";
import QuestionModal from "./QuestionModal";
import { useSelector } from "react-redux";
import { AxiosError } from "axios";
import { message } from "antd";


const UserQuizAttempt = ({ quiz }: { quiz: TQuiz }) => {
  const [quizAttempts, setQuizAttempts] = useState<TQuizAttempt[]>([]);
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [questions, setQuestions] = useState<TQuestion[]>([]);
  const [getedAttempt, setGetedAttempt] = useState<TQuizAttempt | null>(null);
  const inProgressAttempt = quizAttempts.find(
    (quiz: any) => quiz.state === "inprogress"
  );

  useEffect(() => {
    setLoading(true);
    moodleApi
      .getQuizUserAttempts(quiz.id)
      .then((response) => {
        const attempts = response.data.attempts;
        console.log("attempts", attempts);

        if (attempts) {
          setQuizAttempts(attempts);
        }
      })
      .catch((e) => {
        message.error(e)
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const onSubmit = () => {
    if (inProgressAttempt) {
      moodleApi
        .getInProgressQuiz(quiz.course, inProgressAttempt.uniqueid)
        .then((response) => {
          console.log("response.data", response.data);
          setQuestions(response.data.questions);
          setIsOpen(true);
          setGetedAttempt(response.data.attempt);
        })
        .catch((e) => {
          message.error(e)
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      moodleApi
        .startAttempt({
          course_id: quiz.course,
          quiz_id: quiz.id,
        })
        .then((response) => {
          console.log("start data", response.data);
          setQuestions(response.data.questions);
          setIsOpen(true);
          setQuizAttempts([...quizAttempts, response.data.attempt]);
          setGetedAttempt(response.data.attempt);
        })
        .catch((e: AxiosError<any>) => {
          if (typeof e.response?.data === "string") {
            message.error(e.response.data)
            return;
          }
          if (e.response?.data) {
            message.error(e.response.data.message)
            return;
          }
          if (
            e.response?.status === 400 &&
            e.response?.data?.exception === "attempts_ended"
          ) {
            // TODO: Уведомление, что попытки кончились!?
            message.error("ettempts_ended")
            return;
          }
          console.log(e);
          message.error(e.message)
        });
    }
  };
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        padding: 20,
      }}
    >
      {loading ? (
        <Spin />
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          {quizAttempts.map((attempt) => {
            return (
              <div key={attempt.id} className="attempt">
                <div>Попытка №{attempt.attempt}</div>
                <div>
                  {attempt.state == "finished" ? (
                    <div style={{ color: "green" }}>Завершена</div>
                  ) : (
                    <div style={{ color: "grey" }}>В процессе</div>
                  )}
                </div>
                <div>
                  Время начала{" "}
                  {moment.unix(attempt.timestart).format("DD-MM-YYYY HH:mm")}
                </div>
                <div>
                  {attempt.state == "finished"
                    ? `Время завершения ${moment
                      .unix(attempt.timestart)
                      .format("DD-MM-YYYY HH:mm")}`
                    : "-"}
                </div>
              </div>
            );
          })}
          <div
            style={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            <Button style={{ marginTop: 20, width: 250 }} onClick={onSubmit}>
              {inProgressAttempt ? "Продолжить решение" : "Начать квиз"}
            </Button>
          </div>
          <QuestionModal
            setQuestions={setQuestions}
            setQuizAttempts={setQuizAttempts}
            attempt={getedAttempt}
            questions={questions}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />
        </div>
      )}
    </div>
  );
};

export default UserQuizAttempt;
